import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import PropTypes from "prop-types";
import {Globals} from "root/DataFunctions/BaseDataFns";
import {genericListboxFetch} from "root/ReactHookForm/ui/DropdownDataProviders";
import {ChildRoles, MessageType} from "root/DataFunctions/Constants";

const ReactHookFormDropdownMessageContacts = (props) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;
    const userRole = props.messageType === MessageType.MESSAGE_TYPE_LIFESTORY ? ChildRoles.CONTRIBUTOR: ChildRoles.MESSAGER;

    useEffect(() => {

        const url = Globals.APIFolder + '/users/current/contacts?user_role='+ userRole + '&direction=send';

        genericListboxFetch( {url:url, keyFieldName:'unenc_user_id', labelFieldName:'fullName', additionalFields:['idusers']}).then((response) =>
        {
            setData ( { loading: false, items: response }) ;
        }) ;

    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}}) : renderDropdown(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}})
    )
}

export default ReactHookFormDropdownMessageContacts;

ReactHookFormDropdownMessageContacts.defaultProps =
{
    defaultClassName: ''
}

ReactHookFormDropdownMessageContacts.propTypes = {
    onChange: PropTypes.func.isRequired
};


